export const LAST_USER = 'lastUser';
export const LAST_PW = 'lastPW';
export const CIRCGEOFENCES = 'circularGeofences';
export const LOCATIONDATA = 'locationData';
export const WAIVERDATA = 'waiverData';
export const DARKTHEME = 'darktheme';
export const RECTGEOFENCES = 'rectangularGeofences';